export type StatusType = 'wait_me' | 'wait_other' | 'completed' | 'expired' | 'link_active' | 'void';

export type FolderItem = {
  folderName?: string;
  id?: number | undefined;
  contractCount?: number;
};
export type Recipient = {
  address: string;
  chainType: string;
  nickName: string;
  role: string;
  signingAt: string;
  signingContent: string;
  status: string;
  email: string;
  contractId?: string;
};

export enum ContractType {
  visual_contract = 'visual_contract',
  link_sign_contract = 'link_sign_contract',
  contract = 'contract',
  visual_contract_instance = 'visual_contract_instance'
}

export type ContractItem = {
  id: string;
  title: string;
  url: string;
  sentBy: string;
  sentByName?: string;
  folderId: string;
  status: StatusType;
  totalSigning: number;
  currentSigned: number;
  date: string;
  signers: { nickName: string; address: string }[];
  recipients: Recipient[];
  enableEncryption: boolean;
  enableExpiration: boolean;
  createdAt: string;
  expireTime: number;
  txId: string;
  clientStatus: StatusType;
  encryptedContractPassword?: string;
  emailSignMessageTemplate: string;
  contractType: ContractType;
  instanceContractId?: string;
  recipientsTotal: number;
  fileContent?: string;
  signingStatus?: string;
};
export type Contracts = {
  page?: number;
  size?: number;
  total?: number;
  data?: ContractItem[];
};

export type ContractsQuery = {
  hidden?: boolean;
  folder?: number | string;
  page?: number;
  size?: number;
  id?: string;
  filter?: string;
  keyword?: string;
  contractType?: 'invite' | 'link' | any;
};

export enum SendType {
  invite = 'invite',
  link = 'link'
}

export enum SIGN_MODE_ENUM {
  OneSignOne = 'OneSignOne',
  AllSignOne = 'AllSignOne'
}
